"use client";

import styles from "@/styles/modules/components/rooms/roomsList.module.scss";
import { Room } from "@/types/wordpress";
import Gallery from "../Gallery";
import Link from "next/link";
import Image from "next/image";
import { useContext } from "react";
import { LanguageContext } from "@/context/languageContext";
import { translate } from "@/utils/translate";

interface RoomsListProps {
  rooms: Room[];
}

export default function RoomsList({ rooms}: RoomsListProps) {
  const { language } = useContext(LanguageContext);
  

  return (
    <section className={styles.roomsList}>
      <div className={styles.roomsListContainer}>
        {(rooms).map((room: Room, i) => (
          <article
            key={i}
            className={`${room.roomsSuite.isSuite ? styles.suite : ""}`}
            data-aos="fadeIn"
            data-aos-delay={100 * i}
          >
            <div className={styles.gallery}>
              {room.contentFields.gallery && (
                <Gallery gallery={room.contentFields.gallery} />
              )}
            </div>
            <div className={styles.info}>
              <div className={styles.text}>
                <h3>{room.title}</h3>
                <div className={styles.icons}>
                  {room.roomsCheckboxes.checkboxSize && (
                    <div className={styles.icon}>
                      <span>{room.roomsCheckboxes.checkboxSize}</span>
                      <Image
                        alt="Square logo"
                        src="/icons/checkbox_square.svg"
                        width={27}
                        height={27}
                      />
                    </div>
                  )}
                  {room.roomsCheckboxes.checkboxPeople && (
                    <div className={styles.icon}>
                      <span>{room.roomsCheckboxes.checkboxPeople}</span>
                      <Image
                        alt="Person logo"
                        src="/icons/checkbox_person.svg"
                        width={22}
                        height={26}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className={styles.links}>
                <Link href={`/${language}/rooms/${room.slug}`}>
                  {translate["findOutMore"][language]}
                </Link>
                <Link href={`https://www.marriott.com/${language === 'de' ? 'de' : 'en-us'}/hotels/vieir-imperial-riding-school-autograph-collection/overview/`}
                  target="_blank">
                  {translate["bookNow"][language]}
                </Link>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
